import { Card, CardContent, CardMedia } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import image from '../../assets/images/document.png';
import { snakeToCamel } from '../../services/Utils';
import ReadIcon from '../ReadIcon/ReadIcon';
import styles from './DocumentPreview.module.scss';

// @ts-ignore
const DocumentPreview = ({ document, selected, ...props }) => {
    const to = `/documents/${document.id}`;

    const handleSelect = (event: any) => {
        event.preventDefault();
        const action = selected ? 'remove' : 'add';
        props.handleSelect(document.id, action);
    };

    const classes = () => {
        const classes = [styles.ReadIcon];
        const state_name = snakeToCamel(document.state.toLowerCase());
        classes.push(styles[state_name]);
        return classes;
    };

    return (
        <div className={classNames(styles.DocumentPreview, { [styles.Selected]: selected })}>
            <Link to={to}>
                <Card style={{ position: 'relative' }}>
                    <ReadIcon className={classNames(classes())} />
                    <CardMedia
                        image={image}
                        title={document.name}
                        className={styles.DocumentImage}
                    />
                    <CardContent className={styles.CardContent}>
                        <Grid container justify="space-between" alignItems="center">
                            <span className={styles.Name}>#{document.id} {document.name}</span>
                            <div style={{ position: 'relative' }}>
                                <small style={{ position: 'absolute', top: '-5px', left: '30px', fontSize: '10px' }}>{document.prayers}</small>
                            </div>
                        </Grid>
                    </CardContent>
                </Card>
                <Grid container direction="column" className={styles.Overlay} justify="space-between">
                    <Icon className={classNames(styles.CheckIcon, { [styles.CheckIconActive]: selected })} onClick={handleSelect}>
                        <CheckCircleIcon />
                    </Icon>
                    <div className={styles.Tags}>
                        {document.referenceTags.map((referenceTag: any) => referenceTag.tag.id).join('; ')}
                    </div>
                </Grid>
            </Link>
        </div>
    );
};

export default DocumentPreview;
